import {
  AllOpeningHours,
  ExtendedStore,
  Route,
  UpdateStoreLegacy,
  populateRoute,
} from "@repo/common"
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"
import { request } from "../api"

async function fetchStore(storeId: string): Promise<ExtendedStore> {
  return await request<ExtendedStore>({
    url: populateRoute(Route.STORE_CONTROLLER__FIND_ONE, storeId),
    method: "GET",
  })
}

async function updateStoreInformation(
  storeId: string,
  data: UpdateStoreLegacy,
) {
  return await request<ExtendedStore>({
    url: populateRoute(Route.STORE_CONTROLLER__UPDATE, storeId),
    method: "PATCH",
    data,
  })
}

async function refreshOpeningHours(
  storeId: string,
): Promise<AllOpeningHours | null> {
  return await request<AllOpeningHours | null>({
    url: populateRoute(Route.STORE__REFRESH_STORE_OPENING_HOURS, storeId),
    method: "POST",
  })
}

export const useRefreshOpeningHours = (storeId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => refreshOpeningHours(storeId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: storeQueries.detail(storeId).queryKey,
      }),
  })
}

export const useUpdateStoreInformation = (storeId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UpdateStoreLegacy) =>
      updateStoreInformation(storeId, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [storeQueries.detail(storeId).queryKey],
      }),
  })
}

const storeQueries = {
  detail: (storeId: string) =>
    queryOptions({
      queryKey: ["store", storeId],
      queryFn: () => fetchStore(storeId),
      staleTime: Number.POSITIVE_INFINITY,
    }),
}

export default storeQueries
